// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Local Payment Calculator
    initPaymentCalculator();

    // Affordability Calculator
    initBudgetCalculator();
}]);

// Payment Calculator widget
window.initPaymentCalculator = function initPaymentCalculator() {

    var deposit = $("#loan-deposit").val();
    var total_loan_amount = $('#loan-amount').val();
    // console.log(deposit, total_loan_amount);

    if(Number(deposit) > Number(total_loan_amount)){
        deposit = total_loan_amount;
        // console.log('deposit greater than loan amount');
        // save value to cookie
        Cookies.set('loandeposit', deposit);
    // }else{
        // console.log('deposit less than loan amount');
    }
    // console.log('total_loan_amount: ', total_loan_amount);
    // console.log('deposit: ', deposit);
    var reduced_loan_amount = (total_loan_amount - deposit).toFixed(2);

    // Loan Amount slider
    $("#loan-amount-slider").slider({
        range: 'min',
        min: 1000,
        max: 60000,
        step: 1,
        disabled: $('#loan-amount').data('disabled'), // disable if on listing page
        value: total_loan_amount, // default value from hidden field
        slide: function(event, ui) {

            // reduced loan amount minus deposit
            reduced_loan_amount = (ui.value - deposit).toFixed(2);
            // console.log(reduced_loan_amount);
            $("#loan-amount").val(reduced_loan_amount).trigger('keyup');
            $("#loan-amount-display").text(ui.value).number(true);

            // Vue trigger
            $('#loan-amount')[0].dispatchEvent(new CustomEvent('keyup'));

            Cookies.set('loanamount', reduced_loan_amount);
        }
    });

    $("#loan-amount").val(reduced_loan_amount); // set hidden field loan amount initial value
    $("#loan-amount-slider").draggable(); // make draggable on touch devices

    // Loan Term buttons
    $("#loan-term-slider button").on('click', function(e) {

        let term = e.target.value;

        $("#loan-term-slider button").removeClass('btn-primary active').addClass('btn-default');
        $(this).addClass('btn-primary active');
        $('#term-months').val(term).trigger('keyup'); // trigger accrue

        // Vue trigger
        $('#term-months')[0].dispatchEvent(new CustomEvent('keyup'));

        if(term > 12){
            label = 'years';
        }else{
            label = 'year';
        }
        // Derick's custom fancy labels
        if (term < 12) {
            $("#term-months-display").text('6 months');
        } else {
            $("#term-months-display").text('6 months to '+ (term / 12) + ' ' + label);
        }

        if ($("#term-months-display__basic").length) {
            label = 'months';
            $("#term-months-display__basic").text((term) + ' ' + label);
            $("#term-months-display__basic_terms").text((term) + ' ' + label);
        }

        // update customer loan settings
        updateLoanSettings('loanterm', term);
    });

    // Loan Term slider
    // $("#loan-term-slider").slider({
    //     range: "min",
    //     min: 6,
    //     max: 72,
    //     step: 6,
    //     value: $("#term-months").val(), // default term value
    //     slide: function(event, ui) {

    //         var term = ui.value;

    //         $("#term-months").val(term).trigger('keyup');

    //         // Vue trigger
    //         $('#term-months')[0].dispatchEvent(new CustomEvent('keyup'));

    //         if(term > 12){
    //             label = 'years';
    //         }else{
    //             label = 'year';
    //         }
    //         // Derick's custom fancy labels
    //         if (term < 12) {
    //             $("#term-months-display").text('6 months');
    //         } else {
    //             $("#term-months-display").text('6 months to '+ (term / 12) + ' ' + label);
    //         }

    //         if ($("#term-months-display__basic").length) {
    //             $("#term-months-display__basic").text((term) + ' ' + label);
    //             $("#term-months-display__basic_terms").text((term) + ' ' + label);
    //         }

    //         // update customer loan settings
    //         updateLoanSettings('loanterm', term);

    //     }
    // });
    // $("#term-months").val($("#loan-term-slider").slider("value"));
    // $("#loan-term-slider").draggable(); // make draggable on touch devices

    // Loan Interest rate slider
    $("#loan-interestrate-slider").slider({
        range: 'min',
        min: 12.95,
        max: 19.95,
        step: 0.05,
        disabled: true,
        value: $("#loan-interestrate").val(), // default int rate
        slide: function(event, ui) {

            var interestrate = ui.value;
            $("#loan-interestrate").val(interestrate).trigger('keyup');

            // Vue trigger
            $('#loan-interestrate')[0].dispatchEvent(new CustomEvent('keyup'));

            $("#loan-interestrate-display").text(interestrate + '%');

            // save value to cookie and update customer loan settings
            updateLoanSettings('loaninterestrate', interestrate);
        },
        create: function( event, ui ) {

            updateLoanSettings('loaninterestrate', $("#loan-interestrate").val());

        }
    });
    // $("#loan-interestrate").val($("#loan-interestrate-slider").slider("value"));
    $("#loan-interestrate-slider").draggable(); // make draggable on touch devices

    // Loan Deposit slider
    if ($("#loan-deposit-slider").length) {
        $("#loan-deposit-slider").slider({
            range: 'min',
            min: 0,
            max: total_loan_amount,
            step: 100,
            value: deposit, // default value
            slide: function(event, ui) {

                deposit = ui.value;

                $("#loan-deposit").val(deposit).trigger('keyup');

                // Vue trigger
                $('#loan-deposit')[0].dispatchEvent(new CustomEvent('keyup'));

                $("#loan-deposit-display").text(deposit).number(true);

                // reduce loan amount
                reduced_loan_amount = ($("#loan-amount-slider").slider('value') - deposit).toFixed(2);

                $("#loan-amount").val(reduced_loan_amount);

                // save value to cookie and update customer loan settings
                updateLoanSettings('loandeposit', deposit);
                $('input[name=paymentfrequency-radio]:checked').trigger('keyup');
            }
        });
        $("#loan-deposit").val($("#loan-deposit-slider").slider("value"));
        $("#loan-deposit-slider").draggable(); // make draggable on touch devices
    }

    // $('input[name=paymentfrequency-radio]').unbind('click').on('click', function(e) {
    $('input[name=paymentfrequency-radio]').unbind('click').bind('click', function(e) {
        e.stopImmediatePropagation();

        var paymentfrequency = $(this).val();
        $('input[name=paymentfrequency]').val(paymentfrequency).trigger('keyup'); // make sure we trigger change event for accrue.js to work correctly

        // Vue trigger
        $('input[name=paymentfrequency]')[0].dispatchEvent(new CustomEvent('keyup'));

        // save value to cookie and update customer loan settings
        updateLoanSettings('loanpaymentfrequency', paymentfrequency);
    });

    $('#paymentfrequency').on('change', function(e) {
        e.stopImmediatePropagation();

        var paymentfrequency = $('input[name=paymentfrequency-radio]:checked').val();
        $('input[name=paymentfrequency]').val(paymentfrequency).trigger('keyup'); // make sure we trigger change event for accrue.js to work correctly

        // Vue trigger
        $('input[name=paymentfrequency]')[0].dispatchEvent(new CustomEvent('keyup'));

        // save value to cookie and update customer loan settings
        updateLoanSettings('loanpaymentfrequency', paymentfrequency);
    });

    // Update Loan Calculator
    // $('#loan-amount').number(true);

    $(".loan-calculator").accrue({

        // operation: "button",
        response_output_div: '.loan-calculator-results',
        response_basic: '<span class="week red">Your %frequency% Repayments*</span><span class="week red loan-calculator-results__subheading">Finance available from 6 months to 6 years</span><span id="loan-weeklypayment" class="price">$%payment_amount%*</span>',
        error_text: '<p>Deposit should be less than loan amount.</p>',

        callback: function(elem, caldata) {

            // New deposit splash
            if (parseFloat(deposit) <= 0) {
                // $('.listing-deposit-splash').show();
                $('.listing-deposit-splash, .car-details-right .vertical-divider').css('visibility', 'visible');
            } else {
                // $('.listing-deposit-splash').hide();
                $('.listing-deposit-splash, .car-details-right .vertical-divider').css('visibility', 'hidden');
            }

            if (caldata != 0) {

                $("#paymentamount").val(caldata.payment_amount_formatted);
                switch(caldata.frequency){
                    case 'Weekly':
                        label = 'week <span class="asterisk">*</span>';
                        var frequency_label = 'PER WEEK';
                        var mob_freq_label = 'pw';
                    break;
                    case 'Fortnightly':
                        label = 'fortnight <span class="asterisk">*</span>';
                        var frequency_label = 'PER FORTNIGHT';
                        var mob_freq_label = 'pf';
                    break;
                    case 'Monthly':
                        label = 'month <span class="asterisk">*</span>';
                        var frequency_label = 'PER MONTH';
                        var mob_freq_label = 'pm';
                    break;
                }

                Cookies.set('frequency_label', frequency_label, {
                    expires: 1
                });

                var weeklyAmount = Math.ceil(caldata.payment_amount_formatted).toFixed(0);

                if ($('.loan-calculator-results__basic').length) {
                    let yearlyAmount =  Math.ceil(weeklyAmount * 52).toFixed(0);
                    let monthlyAmount = Math.ceil(yearlyAmount / 12).toFixed(0);

                    $('.loan-weeklypayment').html('<sup>$</sup>' + weeklyAmount + '<small>/wk</small>');
                    $('.loan-monthlypayment').html('<sup>$</sup>' + monthlyAmount + '<small>/mth</small>');

                    $('.disclaimer-totalamount').text(caldata.total_payments_formatted).number(true,2);

                } else {

                    $('.listing-paymentfrequency').html('per '+label);
                    $('.listing-paymentfrequency-amount').text('$'+ weeklyAmount );
                    $("#loan-weeklypayment").text('$' + weeklyAmount );
                    $('.disclaimer-frequency').text(caldata.frequency);
                    $('.disclaimer-term').text(caldata.num_payments);
                    $('.disclaimer-deposit').text((deposit > 0 ? '$' + deposit : 'No') + ' deposit');

                    // mobile
                    $('.listing-price .listing-weekly-price').text('$'+ weeklyAmount );
                    $('.listing-price .listing-payment-freq').text(mob_freq_label + '*');

                    // calculate total repayment amount (calculation of the payments multiplied by the term)
                    $('.disclaimer-totalamount').text(caldata.total_payments_formatted).number(true,2);
                    $('#totalamount').val(caldata.total_payments_formatted);
                }
            }else{
                $('.listing-paymentfrequency-amount').text($('.listing-paymentfrequency-amount').data('default'));
                $('.disclaimer-amount').text('Weekly');
            }

            // console.log(weeklyAmount);

        }
    });


    function updateLoanSettings(fieldname, value){

        Cookies.set(fieldname, value, {
            expires:1
        });

        // if customer is loggedin
        // if ($('body').hasClass('loggedin')) {
        //     $.ajax({
        //         url: '/app/post/',
        //         method: 'post',
        //         data: {
        //             'saction' : 'UPDATELOANSETTINGS',
        //             'fieldname' : fieldname,
        //             'value' : value
        //         }
        //     });
        // }

    }

    // apply for finance from vehicle or finance calculator
    $('.btn-applyfromvehicle, .btn-applyforfinance').on('click', function(e){
        e.preventDefault();

        // get calculator values
        var loanamount       = $('#loan-amount').val();
        var paymentamount    = $('#paymentamount').val();
        var loanterm         = $('#term-months').val();
        var interestrate     = $('#loan-interestrate').val();
        var deposit          = $('#loan-deposit').val();
        var paymentfrequency = $('#paymentfrequency').val();

        // console.log(paymentamount, loanterm, interestrate, deposit, paymentfrequency);

        // from vehicle
        if($(this).hasClass('btn-applyfromvehicle')){

            var href = $(this).data('href') + '&loanamount=' + loanamount + '&paymentamount=' + paymentamount + '&loanterm=' + loanterm + '&interestrate=' + interestrate + '&deposit=' + deposit + '&paymentfrequency=' + paymentfrequency;
        }else{

            var href = $(this).data('href') + '?loanamount=' + loanamount + '&paymentamount=' + paymentamount + '&loanterm=' + loanterm + '&interestrate=' + interestrate + '&deposit=' + deposit + '&paymentfrequency=' + paymentfrequency;
        }

        // redirect to application form
        document.location.href = href;

    });
}

// Affordability Calculator
window.initBudgetCalculator = function initBudgetCalculator() {
    $('#btn-calculate').on('click', function() {
        calculateBudget();

        // Track analytics event
        if (typeof ga !== 'undefined') {
            ga('send', 'event', 'Buttons', 'Calculate', 'Affordability Calculator');
        }
    });
    // Toggle partner income/expense fields
    $('input[name=affordability_loantype]').on('click', function(event) {
        var partnerfields = $('#affordability-partner');
        if ($(this).val() == 'joint') {
            partnerfields.slideDown();
        } else {
            partnerfields.slideUp();
        }
    });
    // clear input fields on focus
    $('#form-calculator input.number').on('click focusin', function() {
        var fieldVal = $(this).val();
        if (fieldVal == 0) {
            this.value = '';
        }
    });
}

// Finance Calculator
window.calculateBudget = function calculateBudget() {

    // if input fields are blank set them to zero
    $('input[type=number]').each(function(el) {
        if ($(this).val() == "") {
            $(this).html(0);
            $(this).val(0);
        }
    });
    // my income / rent
    var income = parseFloat($('#income').val()); // .toFloat();
    var incomeFreq = $('#income-freq').val();
    var rent = parseFloat($('#rent').val()); // .toFloat();
    var rentFreq = $('#rent-freq').val();

    // partners income / rent
    var partnerIncome = parseFloat($('#partner-income').val()); //.toFloat();
    var partnerIncomeFreq = $('#partner-income-freq').val();
    var partnerRent = parseFloat($('#partner-rent').val()); //.toFloat();
    var partnerRentFreq = $('#partner-rent-freq').val();

    // other expenses / cost of living
    var bills = parseFloat($('#bills').val() * $('#bills-freq').val()); //.toFloat();
    var liveTogether = parseFloat($('#livetogether').val()); //.toFloat();
    var dependants = parseFloat(($('#dependants').val() * 224)); //.toFloat();
    var surplus = 350; // get surplus

    // combined income
    var combinedIncome = (income * incomeFreq) + (partnerIncome * partnerIncomeFreq);

    // combine expenses
    var totalRent = (rent * rentFreq) + (partnerRent * partnerRentFreq);
    var costOfLiving = totalRent + bills + liveTogether + dependants + surplus;

    var totalExpenses = totalRent + costOfLiving;

    // get affordability amount
    var affordability = Math.round((combinedIncome - costOfLiving).toFixed(2));


    // week price range min / max
    // min
    var minWeeklyPayment = Math.round((affordability / 4.33).toFixed(2));
    var maxWeeklyPayment = Math.round((minWeeklyPayment * 1.25).toFixed(2));

    // max
    //$('weekly-range').set('html', affordability);

    if (income > 0) {
        //alert(minWeeklyPayment);
        // if result is <=$30
        if (minWeeklyPayment <= 30) {
            result = '<h4 class=mb-3>Your affordability looks like it could be tight, please submit a full finance application for us to review.</h4>';
        } else {
            result = '<h4 class=mb-3>How about you look at cars between <b>$' + minWeeklyPayment + '</b> and <b>$' + maxWeeklyPayment + '</b> a week.</h4><p><a href="/usedcar/?paymentmax=' + maxWeeklyPayment + '" class="btn btn-primary btn-md rounded-pill btn-block w-100">View cars in this price range</a></p>';
        }
        // update result
        $('#finance-calc-result').html(result);
        $('#finance-calc-result').css("display", "block");
    } else {
        //return false;
        alert('Please enter your income amount!');

    }
}